export const listUrls = {
  list: '/maillist',
  listOnly: '/maillistonly',
  activeContacts: '/maillist/active-contacts-data',
  unsubscribeContacts: '/maillist/unsubscribe-contacts-data',
  listRefresh: 'maillistrefresh'
};

export const tagUrl = {
  tag: '/mailtag',
  tagRefresh: 'mailtagrefresh'
};

export const categoryUrl = '/category';

export const segmentUrls = {
  segment: '/mailsegment',
  refreshSegment: '/segment/refresh',
  getSegmentLeads: '/segmentleads',
  listing: '/listing/mailsegment'
};

export const sequenceUrls = {
  sequence: '/mailsequence',
  fetchSequence: '/sequence',
  cloneSequence: '/sequence-clone',
  sequenceModule: '/mailsequencemodule',
  sequenceEmailLink: '/sequence/link'
};

export const formUrls = {
  formListing: '/forms',
  form: '/mailform',
  archiveForm: '/archiveform',
  optinForm: '/optinform',
  saveUserDetails: '/saverawuserdetails'
};

export const broadcastUrls = {
  broadcast: '/campaign',
  broadcastList: '/broadcast/list',
  trackingLink: '/campaign-tracking-link',
  deleteBroadcast: '/delete/campaign',
  stopProcessingBroadcast: '/stop/campaign',
  cloneEmailTemplate: '/email/template/clone',
  getCampaignTags: '/get-campaign-tags',
  emailTemplate: '/email/template',
  createEmailTemplate: '/email/template/create',
  sendEmailLeads: '/sendemailleads',
  openedBroadcasts: '/who/opened',
  clickedBroadcastLinks: '/who/clicked',
  failedRecipientList: '/campaign/failed-recipient-list',
  getCampaignLeads: '/campaignsleads',
  addCampaignTags: '/add-campaign-tags',
  campaignTags: '/campaign-tags',
  postalBroadcast: '/postal/broadcast',
  broadcastByTags: '/campaign/by/tags'
};

export const sendTestMail = '/send-test-mail';

export const contactsUrls = {
  contactsList: '/lead/list'
};

export const userEmailSendLimitUrls = {
  remainingEmailCount: '/user/remaining-emails/count',
  planRestriction: '/plan/restriction'
};

export const fetchCustomFieldsUrl = '/customfield-variables';

export const sendersUrl = {
  fetchSenderDataUrl: '/email-sms-sender',
  smsSenders: '/sms-sender',
  emailSenders: '/sender',
  senders: '/sender',
  senderEmailVerification: '/sender/email-reverification',
  recipient: '/recipient',
  recipientEmailVerification: 'recipient/resend-verification'
};

export const settingUrls = {
  getUnsubscribeLayout: '/setting/get-unsubscribe-layout'
};

export const templateUrl = {
  userTemplate: '/user/template',
  createUserTemplate: '/user/template/create',
  globalTabFilters: '/filter/all',
  otherTabFilters: '/user-template-folders',
  adminTemplateSubCategories: '/admin/template-subcategory',
  templateSubCategory: '/template-subcategory',
  templateRowCreate: '/user/row/create',
  templateRow: 'user/row',
  userTemplateClone: '/user/template/clone',
  userTemplateListing: '/user/template/list',
  emailTemplateListing: '/email/template/list'
};

export const adminUrls = {
  mainSettingsUrl: {
    updateBounceBlockSettings: '/admin/setting/update',
    fetchBounceBlockSettingsData: '/adminsetting',
    fetchBccEmailsData: '/admin/setting/get-bcc-emails',
    updateBccEmails: '/admin/setting/update-bcc-emails',
    fetchMessagesData: '/get-default-messages',
    updateMessagesData: '/store-default-messages',
    fetchTransactionMailSettings: '/transactional-messages-percentage',
    updateTransactionMailSettings: '/update-transactional-messages-percentage',
    fetchSenderVerificationSetting: '/admin/get-sender-setting',
    updateSenderVerificationSetting: '/admin/sender-setting',
    fetchMailingSetting: '/admin/get-can-mail-setting',
    updateMailingSetting: '/admin/update-can-mail-setting',
    fetchUnsubscribeData: '/setting/get-unsubscribe-layout',
    updateUnsubscribeDataSetting: '/admin/setting/update-unsubscribe-layout',
    fetchAbuseReportLimit: '/get-abuse-report-limit',
    updateAbuseReportLimit: '/post-abuse-report-limit',
    fetchSpamBlockedLimit: '/get-spam-blocked-limit',
    updateSpamBlockedLimit: '/post-spam-blocked-limit'
  },
  blocklistsUrls: {
    blockDomainsInEmailContent: '/admin/blocklist-domains-mailcontent',
    blockListEmails: '/admin/blacklistemails',
    blockListEmailsAddViaImport: '/admin/upload-blacklistemails-csv',
    downloadSampleForBlockedEmails:
      '/admin/sample-blacklist-emails-csv-download',
    blockListFromDomains: '/admin/blacklist-from-domains',
    downloadSampleForBlockedFromDomains:
      '/admin/sample-blacklist-domains-csv-download',
    blockListFromDomainsAddViaImport:
      '/admin/upload-blacklist-from-domains-csv',
    blockListDomains: '/admin/blacklistdomains',
    blockListDomainsAddViaImport: '/admin/upload-blacklistdomains-csv',
    hardBounceListing: '/admin/hard-bounces-list',
    spamBounceListing: '/admin/spam-bounces-list',
    safeListUser: '/admin/safelist',
    safeListHardbouncedEmails: '/admin/hardbounce/emails',
    safeListHardbouncedEmailsViaImport:
      '/admin/import/email/hardbounce/to/safelist',
    downloadSampleForWhitelistEmails:
      '/admin/sample-whitelist-emails-csv-download'
  },
  adminCampaignsUrls: {
    campignListing: '/admin/campaign/list'
  },
  adminFormsUrl: {
    formsListing: '/admin/mailform/list',
    formsSubscribers: '/formsubscribers'
  },
  grooveUsersUrl: {
    usersListing: '/admin/users-listing',
    changeMailingStatusForAll: '/admin/all-enable-disable',
    changeMailingStatusForUser: '/admin/enable-mail',
    changeBlockStatusForUser: '/admin/block-unblock-user',
    changeSMTPAccessForUser: '/admin/enable-groovemail-smtp',
    changeImportAccessForUser: '/admin/enable-groovemail-import'
  },
  verificationMailUrl: {
    updateVerificationMailContent: '/admin/setting/update-verification-email',
    getVerificationMailData: '/admin/setting/get-verification-email'
  },
  importManagementUrl: {
    importListingUrl: '/admin/user-leads-listing',
    rejectAllLeads: '/admin/user-leads-reject',
    approveAllLeads: '/admin/approve-all-leads',
    approveGoodLeads: '/admin/approve-good-leads',
    downloadAllLeads: '/admin/download-user-leads',
    downloadGoodLeads: '/admin/download-good-lead-csv',
    downloadBadLeads: '/admin/download-bad-lead-csv'
  },
  ipBlockUrl: {
    blockedIPListing: '/admin/blockIp-listing',
    unblockIP: '/admin/unblock-blockIp'
  },
  ipSafeListUrl: {
    safelistedIPData: '/admin/whitelist_ips',
    safelistIPs: '/admin/whitelist_ips',
    uploadIPsToSafelist: '/admin/upload-whitelistips-csv',
    downloadSampleForSafelistIPUpload:
      '/admin/sample-whitelist-ips-csv-download'
  },
  smtpUrl: {
    smtpData: '/adminsmtp',
    smtpPoolTypes: '/pool-types',
    smtpTierTypes: '/smtp-type',
    sendTestMailForSMTP: '/admin/smtp-send-mail'
  },
  adminSequenceUrls: {
    sequenceListing: '/admin/sequence-emails'
  },
  trackingDomainUrl: {
    trackingDomain: '/track-domain'
  },
  userSendersUrl: {
    sendersListing: '/admin/users-senders'
  },
  spamAlertUrls: {
    alertSetting: '/alertsetting',
    updateAlertSetting: '/alertsetting/update',
    spamAlerts: '/spam-alerts',
    userAlerts: '/user-alerts'
  },
  bounceMessageUrls: {
    messageListing: '/admin/hardbouncemessage',
    downloadSampleMessages: '/admin/samplefile/hardbouncemessage',
    downloadBounceMessages: '/admin/export/hardbouncemessage',
    importBounceMessages: '/admin/import/hardbouncemessage',
  },
};

export const getBlockedDomainsAndMessages = '/get-blocked-domains-and-messages';

export const customFieldUrls = {
  customField: '/customfield'
};

export const externalAppsUrl = {
  promos: '/groovesell/promos',
  affiliateLinks: '/groovesell/affiliate-links',
  funnelsBreakdown: '/groovesell/funnels-breakdown',
  commissionTiers: '/groovesell/fetch-commission-tiers',
  groovememberMemberships: 'https://v1.gdapis.com/api/groovemember/memberships'
};

export const suppressorsUrl = {
  complainers: '/complainers',
  addComplainers: '/add-complainers-to-suppression',
  unsubscribers: '/unsubscribers',
  sampleUnsubscribersCsvDownload:
    '/unsubscribers/sample-unsubscribers-csv-download',
  uploadUnsubscribersCsv: '/unsubscribers/upload-unsubscribers-csv',
  suppressionEmails: '/suppression-emails',
  uploadEmailsCsv: '/suppression-emails/upload-emails-csv',
  sampleEmailsCsvDownload: '/suppression-emails/sample-emails-csv-download',
  suppressionDomains: '/suppression-domains',
  uploadDomainsCsv: '/suppression-domains/upload-domains-csv',
  sampleDomainsCsvDownload: '/suppression-domains/sample-domains-csv-download',
  suppressionTlds: '/suppression-tlds',
  uploadTldsCsv: '/suppression-tlds/upload-tlds-csv',
  sampleTldsCsvDownload: '/suppression-tlds/sample-tlds-csv-download',
  addUnsubscribersToComplainers: '/add-unsubscribers-to-complainers',
  addComplainersToSupression: '/add-complainers-to-suppression'
};

export const dashboardUrls = {
  dashboard: '/dashboard',
  dashboardCountData: '/getCount',
  dashboardChartValue: '/getChartValue',
  dashboardTopCampaigns: '/dashboard-top-campaigns'
};

export const userSettingUrl = '/usersetting';

export const userImportListingUrl = '/imports-listing';

export const automationsv2Urls = {
  automation: '/automation_v2',
  automationList: '/automation_v2/list',
  automationFilters: '/automation_v2/filters',
  automationTriggers: '/automation_v2/dropdown/triggers',
  automationConditions: '/automation_v2/dropdown/conditions',
  automationActions: '/automation_v2/dropdown/actions'
};

export const automationUrls = {
  automation: '/automation',
  resetStats: '/resetstats'
};

export const leadUrls = {
  downloadLeadCSV: '/download-lead-csv',
  maillead: '/maillead',
  leadListing2: '/lead/list',
  removeTagList: '/remove/list/tag',
  removeSequence: '/remove-from-sequence',
  getDefaultMessages: '/get-default-messages',
  importSafeDomainCheck: '/import-safe-domain-check',
  emailVerification: '/website-email-verification-send',
  emailOtpVerification: 'website-email-otp-verify',
  importLeads: '/import-leads/upload-leads-csv',
  downloadSampleUserLeads: '/user-leads/sample-user-leads-csv-download',
  fileLeadUpload: '/import-leads/file-upload-leads-csv'
};
